<p-toast *ngIf="!embedded && !commonService.isMobileView" position="top-right" key="mfa-toast"></p-toast>
<p-toast position="top-right" [breakpoints]="{'991px': {width: '100%', right: '0', left: '0'}}" *ngIf="!embedded && commonService.isMobileView" key="mfa-toast"></p-toast>

<ng-template #mfaFormTemplate>
  <form class="forms-sample" [class.ml-3]="!embedded" [class.mr-3]="!embedded" [formGroup]="mfaForm" (submit)="onVerifyOtp($event)" autocomplete="off">
    <div class="form-group">
      <label for="exampleInputPassword1">Security code</label>
      <input autofocus placeholder="6 Digit code" inputmode="numeric" class="form-control" formControlName="otp" maxlength="6" required>
      <div *ngIf="mfaForm.controls.otp.invalid && mfaForm.controls.otp.dirty">
        <ngb-alert [dismissible]="false" [type]="'danger'">
          {{'errorMsg.missingSecurityCode' | translate}}
        </ngb-alert>
      </div>
    </div>
    <p *ngIf="native == 'auth'">
      Security code sent to <b> {{user?.email}} </b> <span *ngIf="user?.phoneNumber"> and phone <b> {{user?.phoneNumber}}
        </b></span>
    </p>
    <p *ngIf="native != 'auth'">
      Security code sent to <b> {{mfaData?.email}} </b> <span *ngIf="mfaData?.phoneNumber"> and phone <b> {{mfaData?.phoneNumber}}
        </b></span>
    </p>
    <div *ngIf="showTermsCheck" class="check-box-card">
      <div class="form-check align-items-center">
        <input type="checkbox" class="form-check-input form-check-box" formControlName="agreed" id="agreeTerms" />
        <label class="form-check-text">
            I agree to the <a class="terms-link logo-tag-line1 " (click)="openTermsModal($event)"><span class="log_forgot">Terms And
                Conditions</span></a>
        </label>
    </div>
    </div>
      <div class="d-flex justify-content-between mt-3">

        <div class="col-md-6 px-0 " >
          <button *ngIf="native == 'auth' || showBackButton" type="button" class="link-btn" tabindex="-1" [disabled]="loaders.logging" (click)="onCancel()">
            <span class="log_forgot">Back</span></button>
        </div>
        <div class="col-md-6 text-right" *ngIf="loaders.timer">
          <span class="timer">
            {{timer}}</span>
        </div>
        <div class="col-md-6 px-0 text-right" tabindex="-1" *ngIf="!loaders.timer">
          <button type="button" class="link-btn" [disabled]="loaders.timer" (click)="onResendCode()">
            <span class="log_forgot">Resend code</span></button>
        </div>

      </div>

      <div class="mt-3">
        <button type="submit" class="btn btn-submit btn-block" [disabled]="loaders.logging || (showTermsCheck && !mfaForm.get('agreed')?.value)">
          <span *ngIf="loaders.logging" class="spinner-border spinner-border-sm" role="status"
            aria-hidden="true"></span><span class="loader_ml">Verify</span></button>

      </div>


  </form>
</ng-template>

<ng-container *ngIf="embedded">
  <ng-container *ngTemplateOutlet="mfaFormTemplate"></ng-container>
</ng-container>

<div *ngIf="!embedded" class="row w-100 mx-0 {{native == 'auth'?'auth-page':''}} ">
  <div class="{{widthClass}} mx-auto">
    <div class="{{isFullWidth?'bg-white':''}} card cus-card login_card">
      <div class="row ml-0 mr-0">

        <div class="{{!isFullWidth?'col-md-5 left-login-card':'col-md-12 pb-3 card-bg-small-size'}} pl-md-2 pr-md-2">
          <div class="auth-form-wrapper px-4 py-4" *ngIf="!isFullWidth">
            <!-- <a routerLink="." class="noble-ui-logo d-block text-center"><img class="logo_align left-logo"
                src="{{environmentData?.defaultLogo}}" alt="IPOSPAYS" /></a> -->
            <!-- <router-outlet></router-outlet> -->
            <!-- <app-login></app-login> -->
          </div>
          <div class="font-color mt-3 px-2">
            <h4> {{title}}</h4>
            <p class="mt-2" style="font-size: 16px;">
              {{content}}
              </p>
            <!-- <p class="ml-1 mr-2 mb-4 pl-2 pr-2">Login to your portal right now!</p> -->
          </div>
          <!-- <a class="ml-3 mr-4 mb-4 pl-4 pr-4" style="color: #fff;" href="">Go To Login</a> -->
          <div *ngIf="showTermsCheck" class="font-color mt-3 px-2 proceed-text">
            <h4>Terms & Conditions</h4>
            <p class="terms-info mt-2">
              Please review the T&C before proceeding.
            </p>
          </div>
        </div>
        <div class="card login-div auth-right-panel {{!isFullWidth?'col-md-7':'col-md-12 mt-3'}} ml-0 mr-0 pl-0 pr-0">
          <div class="{{!isFullWidth?'mt-5':'mt-2'}} mb-2 ml-0 mr-0 pl-0 pr-0">

            <!-- <h3 class="font-weight-normal mb-4 text-center"><b>Welcome back!</b> Log in to your account.</h3> -->
            <!-- <h5 class="font-weight-normal mb-4 text-center">Get started by entering your login credentials</h5> -->
            <ng-container *ngTemplateOutlet="mfaFormTemplate"></ng-container>

          </div>
          <footer class="pb-2 mt-2" *ngIf="native == 'auth'">
            <!-- {{environmentData?.portalMerchantLogoPath+'/'+environmentData?.defaultLogo}} -->
            <a routerLink="." *ngIf="!loginLogo" class="noble-ui-logo text-center d-block log_align"><img
                src="{{environmentData?.defaultLogo}}" alt="IPOSPAYS" class="footer-image" /></a>
                <a routerLink="." *ngIf="loginLogo" class="noble-ui-logo d-block text-center"><img class="logo_align left-logo" src="{{loginLogo}}"
                  alt="IPOSPAYS" /></a>
            <p  *ngIf="!loginLogo" class="text-center font-weight-normal logo-tag-line">It's <span>more</span> than a transaction!</p>
            <p *ngIf="tagName" class="text-center font-weight-normal logo-tag-line">{{tagName}}</p>

          </footer>
        </div>
      </div>
    </div>
  </div>
</div>